(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dua-product-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeReviews(root) {
    root.querySelectorAll('[data-review-marquee]:not([data-ready])').forEach(function (track) {
      track.dataset.ready = 'true';
      var rail = track.querySelector('.dua-product-reviews__rail');
      var group = rail && rail.querySelector('.dua-product-reviews__group');
      if (!group || !group.children.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var copy = group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.querySelectorAll('*').forEach(function (element) {
        Array.from(element.attributes).forEach(function (attribute) {
          if (attribute.name.indexOf('data-shopify-editor-') === 0) element.removeAttribute(attribute.name);
        });
      });
      rail.appendChild(copy);
      var paused = false;
      var resumeTimer;
      var lastTime = 0;
      function tick(time) {
        if (!document.contains(track)) return;
        if (!paused && !document.hidden) {
          var distance = group.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
          track.scrollLeft += Math.min(Math.max(time - lastTime, 0), 100) * 0.035;
          if (distance && track.scrollLeft >= distance) track.scrollLeft -= distance;
        }
        lastTime = time;
        requestAnimationFrame(tick);
      }
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('focusin', function () { paused = true; });
      track.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
      track.addEventListener('touchend', function () { resumeTimer = setTimeout(function () { paused = false; }, 2000); }, { passive: true });
      requestAnimationFrame(tick);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeReviews(document); });
  else initializeReviews(document);
  document.addEventListener('shopify:section:load', function (event) { initializeReviews(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeature(root) {
    root.querySelectorAll('[data-home-feature]:not([data-feature-ready])').forEach(function (feature) {
      feature.dataset.featureReady = 'true';
      var main = feature.querySelector('.pm-zafrani-feature__image');
      var thumbs = feature.querySelectorAll('[data-feature-photo]');
      thumbs.forEach(function (button) {
        button.addEventListener('click', function () {
          if (main) { main.src = button.dataset.largeSrc; main.srcset = ''; main.alt = button.dataset.photoAlt; }
          thumbs.forEach(function (thumb) { thumb.classList.toggle('is-active', thumb === button); thumb.setAttribute('aria-pressed', thumb === button ? 'true' : 'false'); });
        });
      });
      var input = feature.querySelector('[data-feature-variant-input]');
      var price = feature.querySelector('[data-feature-price]');
      var compare = feature.querySelector('[data-feature-compare]');
      var cod = feature.querySelector('[data-y-direct-checkout]');
      var cart = feature.querySelector('[data-y-add-button]');
      var variants = feature.querySelectorAll('[data-feature-variant]');
      variants.forEach(function (button) {
        button.addEventListener('click', function () {
          input.value = button.dataset.id;
          price.textContent = button.dataset.price;
          compare.textContent = button.dataset.compare || '';
          compare.hidden = !button.dataset.compare;
          cart.disabled = button.dataset.available !== 'true';
          if (cod) cod.disabled = button.dataset.available !== 'true';
          variants.forEach(function (variant) { variant.classList.toggle('is-active', variant === button); variant.setAttribute('aria-pressed', variant === button ? 'true' : 'false'); });
        });
      });
      var quantity = feature.querySelector('input[name="quantity"]');
      feature.querySelector('[data-feature-decrease]')?.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
      feature.querySelector('[data-feature-increase]')?.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); });
    });
  }
  function initHomeReviews(root) {
    root.querySelectorAll('.pm-review-list[data-review-marquee]:not([data-ready])').forEach(function (track) {
      track.dataset.ready = 'true';
      var rail = track.querySelector('.pm-review-list__rail');
      var group = rail && rail.querySelector('.pm-review-list__group');
      if (!group || !group.children.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var copy = group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.querySelectorAll('*').forEach(function (element) {
        Array.from(element.attributes).forEach(function (attribute) {
          if (attribute.name.indexOf('data-shopify-editor-') === 0) element.removeAttribute(attribute.name);
        });
      });
      rail.appendChild(copy);
      var paused = false;
      var resumeTimer;
      var lastTime = 0;
      function tick(time) {
        if (!document.contains(track)) return;
        if (!paused && !document.hidden) {
          var gap = parseFloat(getComputedStyle(rail).gap) || 0;
          var distance = group.getBoundingClientRect().width + gap;
          track.scrollLeft += Math.min(Math.max(time - lastTime, 0), 100) * 0.035;
          if (distance && track.scrollLeft >= distance) track.scrollLeft -= distance;
        }
        lastTime = time;
        requestAnimationFrame(tick);
      }
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('focusin', function () { paused = true; });
      track.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
      track.addEventListener('touchend', function () { resumeTimer = setTimeout(function () { paused = false; }, 2000); }, { passive: true });
      requestAnimationFrame(tick);
    });
  }
  function initSection(root) { initFeature(root); initHomeReviews(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initSection(document); });
  else initSection(document);
  document.addEventListener('shopify:section:load', function (event) { initSection(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
